module.exports = __webpack_public_path__ + "static/media/te.ca774100.png";